export const addVolumeItems = (volumeItem) => {
    return {
        type: 'ADD_VOLUME_ITEMS',
        volumeItem
    };
};

export const addVolumeRegistrations = (volumeRegistration) => {
    return {
        type: 'ADD_VOLUME_REGISTRATIONS',
        volumeRegistration
    };
};

export const removedVolumeItem = (volumeItem) => {
    return {
        type: 'REMOVED_VOLUME_ITEMS',
        volumeItem
    };
};

export const removedVolumeRegistration = (volumeRegistration) => {
    return {
        type: 'REMOVED_VOLUME_REGISTRATIONS',
        volumeRegistration
    };
};

export const UpdateVolumeConfiguration = (volumeConfiguration) => {
    return {
        type: 'UPDATE_VOLUME_CONFIGURATION',
        volumeConfiguration
    };
};

export const updateVolumeItem = (volumeItem) => {
    return {
        type: 'UPDATE_VOLUME_ITEM',
        volumeItem
    };
};

export const setMarketplace = (marketplace) => {
    return {
        type: 'SET_MARKETPLACE',
        marketplace
    };
};

export const setPacking = (packing) => {
    return {
        type: 'SET_PACKING',
        packing
    };
};

export const updateWeight = (packing) => {
    return {
        type: 'UPDATE_WEIGHT',
        packing
    };
};


export const resetVolume = () => {
    return {
        type: 'RESET_VOLUME'
    };
};


export const setVolumeType = (volumeType) => {
    return {
        type: 'SET_VOLUME_TYPE',
        volumeType
    };
};


